import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "app-checkbox" }
const _hoisted_2 = { class: "app-checkbox__item" }
const _hoisted_3 = ["disabled", "name", "checked"]

import { computed } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

type checkboxProps = {
	disabled?: boolean;
	size?: "md";
	shape?: "square" | "round";
	text?: string;
	value?: boolean;
	valueOn?: boolean;
	valueOff?: boolean;
};

type checkboxEmit = {
	"on-change": [event: object];
	"on-input": [value: boolean];
	"update:value": [value: boolean];
	input: [value: boolean];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AppCheckbox',
  props: {
    disabled: { type: Boolean },
    size: { default: "md" },
    shape: { default: "square" },
    text: { default: "" },
    value: { type: Boolean, default: false },
    valueOn: { type: Boolean, default: true },
    valueOff: { type: Boolean, default: false }
  },
  emits: ["on-change", "on-input", "update:value", "input"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isChecked = computed(() => props.value === props.valueOn);

const onInput = (event: Event) => {
	if (!event.target) return undefined;
	const target = event.target as HTMLInputElement;
	const value = target.checked ? props.valueOn : props.valueOff;
	emit("on-change", event);
	emit("on-input", value);
	emit("update:value", value);
	emit("input", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        class: "app-checkbox__core",
        type: "checkbox",
        disabled: props.disabled,
        name: props.text,
        checked: _ctx.value === _ctx.valueOn,
        onInput: onInput
      }, null, 40, _hoisted_3),
      (props.shape === 'square')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({
					'app-checkbox__item-label': true,
					[`app-checkbox__item-label__${props.size}`]: true,
					'app-checkbox__item-label__disabled':props.disabled,
					// 'app-checkbox__item-label__disabled-checked':props.disabled && props.value,
				})
          }, null, 2))
        : (_openBlock(), _createBlock(AppIcon, {
            key: 1,
            name: isChecked.value ? 'checked-round' : 'unchecked-round',
            size: "16px",
            class: _normalizeClass({
					'app-checkbox__item-round': true,
					'app-checkbox__item-round__disabled': props.disabled,
				})
          }, null, 8, ["name", "class"])),
      (_ctx.text)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass({
					'app-checkbox__item-text': true,
					[`app-checkbox__item-text__${props.size}`]: true,
				})
          }, _toDisplayString(props.text), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})